module.exports = __webpack_public_path__ + "img/arrow.9e5476d6.svg";